import clsx from 'clsx'
import type { ReactNode } from 'react'
import { CornerBrackets } from './CornerBrackets'

// Glass panel + corner bracket(s) — the workhorse container (DESIGN.md §7).
// Every glass panel pairs with ≥1 bracket so glass never reads generic.
export function HudCard({ children, header, brackets = true, className }: {
  children: ReactNode; header?: ReactNode; brackets?: boolean; className?: string
}) {
  return (
    <div className={clsx('hud-card glass', className)}>
      {brackets && <CornerBrackets size={14} />}
      {header && <div className="hud-card-head label">{header}</div>}
      {children}
    </div>
  )
}
